import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./batscorecard.css";

function Scoreboardbatting() {
  const matchId = localStorage.getItem("match_id");
  const navigate = useNavigate();
  const scoreRef = useRef();
const [team1 ,setTeam1] = useState("");
  const [batting, setBatting] = useState([]);
  const [extras, setExtras] = useState({});
  const [matchSummary, setMatchSummary] = useState({});

  useEffect(() => {
    fetch(`https://nammateam.onrender.com/battinstats/${matchId}`)
      .then(res => res.json())
      .then(data => { if (data.success) setBatting(data.batsmen); });

    fetch(`https://nammateam.onrender.com/match/extras/${matchId}`)
      .then(res => res.json())
      .then(data => { if (data.success) setExtras(data.extras); });

 fetch(`https://nammateam.onrender.com/match/${matchId}`)
      .then(res => res.json())
      .then(datas => {const batting_team =
          datas.toss_winner === datas.host_team
            ? (datas.opt_to === 'bat' ? datas.host_team : datas.visitor_team)
            : (datas.opt_to === 'bat' ? datas.visitor_team : datas.host_team);
       
if(batting_team === datas.host_team)
{
 setTeam1(datas.host_team);

}
      });

    fetch(`https://nammateam.onrender.com/match/summary/${matchId}`)
      .then(res => res.json())
      .then(data => { if (data.success) setMatchSummary(data); });
  }, [matchId]);

  return (
    <div className="fsc-container">
      {/* Header */}
      <div className="fsc-header">
        <button className="fsc-back" onClick={() => navigate("/live")}>← Back</button>
        <h2>Batting Scorecard</h2>
      </div>

      <div ref={scoreRef} className="fsc-content">
        <div className="fsc-match-title">
          <h3>{team1 || "Team 1"} Batting</h3>
          <p>{matchSummary.result || ""}</p>
        </div>

        {/* Batting Table */}
        <div className="fsc-section">
          <table className="fsc-table">
            <thead>
              <tr>
                <th>Batsman</th>
                <th>R</th>
                <th>B</th>
                <th>4s</th>
                <th>6s</th>
                <th>SR</th>
              </tr>
            </thead>
            <tbody>
              {batting.map((b, i) => (
                <tr key={i} className={b.is_out ? "" : "fsc-notout-row"}>
                  <td>
                    {b.batsman_name}
                    <br />
                    <small className={`fsc-status ${b.is_out ? "" : "fsc-notout"}`}>
                      {b.is_out
                        ? `${b.out_type}${b.out_bowler ? ` - Bowler: ${b.out_bowler}` : ""}${b.out_help ? ` Help: ${b.out_help}` : ""}`
                        : 'not out'}
                    </small>
                  </td>
                  <td>{b.runs}</td>
                  <td>{b.balls_faced}</td>
                  <td>{b.fours}</td>
                  <td>{b.sixes}</td>
                  <td>{b.strike_rate}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="fsc-extras">
            Extras: ({extras.total || 0}) {`B ${extras.byes || 0}, LB ${extras.leg_byes || 0}, WD ${extras.wides || 0}, NB ${extras.no_balls || 0}, P ${extras.penalty || 0}`}
          </div>
          <div className="fsc-total">
            Total: {matchSummary.total_runs || 0}-{matchSummary.total_wickets || 0} ({matchSummary.overs || "0.0"})
          </div>
        </div>
      </div>
    </div>
  );
}

export default Scoreboardbatting;
